import React, { useState } from 'react';
import {
    CNVIcon,
    ExomeIcon,
    RNASeqIcon,
    CrisprKOIcon,
    FusionIcon,
    DrugIcon,
    MetIcon,
    PatientIcon,
    ModelIcon,
    GeneIcon,
    ProteomicsIcon
    
} from '../icons/icons';

//import MultiomicsLogo from "../../../assets/img/logo_cmp.png"

import {Collapse, Button, CardBody, Card} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import _ from 'lodash'

import DownloadGroup from './downloadGroup';

const infoIcon = <span className="fa-wrapper mr-2 pt-1"><FontAwesomeIcon icon={faInfoCircle} style={{height: "2.5rem",width: "1.5rem", verticalAlign: "middle", color: "#000000"}}/></span>
const infoDocs = <a href="https://depmap.sanger.ac.uk/documentation/" target="_blank" rel="noopener noreferrer">Documentation</a>

let getIcon = (icon) => {
    switch(icon){
        case "drugs":
            return <DrugIcon style={{height: "2.5rem", verticalAlign: "middle"}}/>;
        case "model":
            return <ModelIcon style={{height: "2.5rem", position: "relative", top: "10px"}}/>;
        case "gene":
            return <GeneIcon style={{height: "2.5rem", position: "relative", top: "14px"}}/>;
        case "mutation":
        case "mutations":
            return <ExomeIcon style={{height: "2.5rem", verticalAlign: "middle"}}/>;
        case "expression":
            return <RNASeqIcon style={{height: "2.5rem", verticalAlign: "middle"}}/>;
        case "cnv":
            return <CNVIcon style={{height: "2.5rem", verticalAlign: "middle"}}/>;
        case "methylation":
            return <MetIcon style={{height: "2.5rem", verticalAlign: "middle"}}/>;
        case "patient":
            return <PatientIcon style={{height: "2.5rem", verticalAlign: "middle"}}/>;
        case "crispr_ko":
            return <CrisprKOIcon style={{height: "2.5rem", verticalAlign: "middle"}}/>;
        case "fusion":
        case "fusions":
            return <FusionIcon style={{height: "2.5rem", verticalAlign: "middle", stroke: "#212529"}}/>;
        case "proteomics":
            return <ProteomicsIcon style={{height: "2.5rem", verticalAlign: "middle"}}/>;
        //case "multiomics":
         //   return <img src={MultiomicsLogo} height="40" alt="Cell Model Passports" />;
        default:
            return "";
    }
};

let getDocs = (icon) => {

    const map = {
        drugs: "drug-sensitivity",
        mutation: "mutation",
        mutations: "mutation",
        expression: "expression",
        cnv: "copy-number",
        methylation: "methylation",
        patient: "",
        crispr_ko: "wg-crispr-knockout",
        fusion: "fusions",
        fusions: "fusions",
        proteomics: "proteomics",
        multiomics: null
    };

    if (icon === "multiomics") {
        return (
            <a
                href="https://doi.org/10.1101/2024.06.26.600742"
                target="_blank"
                rel="noopener noreferrer"
            >
                Documentation
            </a>
        );
    }

    if (!(icon in map)) {
        console.log("UNKNOWN ICON:", icon);   // ⭐ DEBUG
        return (
            <a
                href="https://depmap.sanger.ac.uk/documentation/"
                target="_blank"
                rel="noopener noreferrer"
            >
                Documentation
            </a>
        );
    }

    return (
        <a
            href={`https://depmap.sanger.ac.uk/documentation/datasets/${map[icon]}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            Documentation
        </a>
    );
};

export default function(props){

    let c = props.category;
    
    let icon = null;
    let docs = null;

    if(c.icon){
        icon = (
    <span style={{display: "flex", alignItems: "center"}}>
        {getIcon(c.icon)}
    </span>
)
        docs = getDocs(c.icon)

    }else{
        icon = (<div className="d-inline-block">{infoIcon}</div>)
        docs = infoDocs
    }

    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);
    
    return(
        <div className="download-category">
      <Button
  color="primary"
  onClick={toggle}
  style={{
    marginBottom: '1rem',
    height: '3.2rem',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  }}
>
  {icon}
  <span>{c.name.replace(/CRISPR KO/g, "CRISPR Dependencies")}</span>
</Button>
      <Collapse isOpen={isOpen}>
  <Card>
    <CardBody>

      <div className="category-docs d-flex justify-content-end">
  {docs}
</div>

      <div className="download-groups">
        {_.sortBy(c.groups, 'order').map(g => (
          <DownloadGroup group={g} key={g.id} />
        ))}
      </div>

    </CardBody>
  </Card>
</Collapse>
    </div>
    )
}